import React from 'react';
import type ProductsJsmOrganizationDetails from '@atlassian/jira-products-jsm-organization-details/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmOrganizationDetails = lazyForPaint<
	typeof ProductsJsmOrganizationDetails
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-organization-details", jiraSpaEntry: "async-products-jsm-organization-details" */ '@atlassian/jira-products-jsm-organization-details/src/ui/index.tsx'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProductsJsmOrganizationDetails}
		pageId="products-jsm-organization-details"
		shouldShowSpinner
	/>
);
